import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "geo-payment-methods__drag-handle" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "geo-payment-methods__type-title" }
const _hoisted_5 = {
  key: 2,
  class: "geo-payment-methods__logo"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "geo-payment-methods__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_PsLimitsDetails = _resolveComponent("PsLimitsDetails")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_FallbackImage = _resolveComponent("FallbackImage")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_PaymentMethodToggle = _resolveComponent("PaymentMethodToggle")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_table, {
    ref: "dragSortingTableRef",
    size: "small",
    class: "geo-payment-methods",
    data: _ctx.extendedGeoPaymentMethodList,
    "row-class-name": _ctx.getRowClassName,
    "row-key": "id",
    border: ""
  }, {
    default: _withCtx(() => [
      (_ctx.isGeoPaymentMethodFullListUpdateAllowed)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "Sort",
            width: "45",
            align: "center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_icon, { size: "22" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icons.DCaret)))
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_el_table_column, {
        type: "index",
        label: "#",
        align: "center",
        width: "35"
      }),
      (_ctx.isGetGeoPaymentMethodDepositLimitsAllowed && _ctx.isDepositColumnsDataVisible)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            type: "expand",
            width: "25",
            fixed: "left",
            "class-name": "geo-payment-methods__expand-column_disabled"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_PsLimitsDetails, {
                "payment-method-settings-id": row.billingPaymentMethodSettingsId
              }, null, 8 /* PROPS */, ["payment-method-settings-id"])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.geoPaymentMethodColumnsList, (column) => {
        return (_openBlock(), _createBlock(_component_el_table_column, {
          key: column.value,
          property: column.value,
          label: column.label,
          align: column.align,
          width: column.width,
          "show-overflow-tooltip": column.isShowOverflowTooltip
        }, {
          default: _withCtx(({ row }) => [
            (column.value === _ctx.GeoPaymentMethodColumnProperties.CURRENCY)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (row.type === _ctx.GeoPaymentMethodTypes.SINGLE)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(row.currencyList.join(', ')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (row.type === _ctx.GeoPaymentMethodTypes.MULTI)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.currency), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            (column.value === _ctx.GeoPaymentMethodColumnProperties.TYPE)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: _ctx.getPaymentMethodTagType(row.type)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(row.type), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"]))
              : _createCommentVNode("v-if", true),
            (column.value === _ctx.GeoPaymentMethodColumnProperties.IMAGE_URL)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_FallbackImage, {
                    "model-value": row,
                    class: "geo-payment-methods__image"
                  }, null, 8 /* PROPS */, ["model-value"])
                ]))
              : _createCommentVNode("v-if", true),
            (column.value === _ctx.GeoPaymentMethodColumnProperties.SEGMENT_LIST)
              ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                  key: 3,
                  "max-height": "70",
                  always: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.segmentList, (segment) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: segment.segmentId
                      }, _toDisplayString(segment.name), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              : _createCommentVNode("v-if", true),
            (column.value === _ctx.GeoPaymentMethodColumnProperties.EXCLUDED_SEGMENT_LIST)
              ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                  key: 4,
                  "max-height": "70",
                  always: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.excludedSegmentList, (segment) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: segment.segmentId
                      }, _toDisplayString(segment.name), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              : _createCommentVNode("v-if", true),
            (column.value === _ctx.GeoPaymentMethodColumnProperties.TAG_LIST)
              ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                  key: 5,
                  "max-height": "70",
                  always: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.tagList, (tag) => {
                      return (_openBlock(), _createBlock(_component_el_tag, {
                        key: tag.tagId,
                        class: "geo-payment-methods__tag",
                        effect: "light",
                        type: "info",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              : _createCommentVNode("v-if", true),
            (column.value === _ctx.GeoPaymentMethodColumnProperties.EXCLUDED_TAG_LIST)
              ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                  key: 6,
                  "max-height": "70",
                  always: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.excludedTagList, (tag) => {
                      return (_openBlock(), _createBlock(_component_el_tag, {
                        key: tag.tagId,
                        class: "geo-payment-methods__tag",
                        effect: "light",
                        type: "info",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tag.name), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              : _createCommentVNode("v-if", true)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["property", "label", "align", "width", "show-overflow-tooltip"]))
      }), 128 /* KEYED_FRAGMENT */)),
      (_ctx.isDepositColumnsDataVisible)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 2,
            label: "Deposit limit",
            width: "140"
          }, {
            default: _withCtx(({ row }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row[_ctx.GeoPaymentMethodColumnProperties.DEPOSIT_LIMIT_LIST], ({ currency, min, max, extendedLimits }) => {
                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                  _createTextVNode(_toDisplayString(currency) + " - " + _toDisplayString(min) + " → " + _toDisplayString(max) + " ", 1 /* TEXT */),
                  extendedLimits
                    ? (_openBlock(), _createElementBlock("b", _hoisted_6, "(" + _toDisplayString(extendedLimits) + " excp.)", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (_ctx.isWithdrawColumnsDataVisible)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 3,
            label: "Withdrawal limit",
            width: "140"
          }, {
            default: _withCtx(({ row }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row[_ctx.GeoPaymentMethodColumnProperties.WITHDRAW_LIMIT_LIST], ({ currency, min, max, extendedLimits }) => {
                return (_openBlock(), _createElementBlock("div", { key: currency }, [
                  _createTextVNode(_toDisplayString(currency) + " - " + _toDisplayString(min) + " → " + _toDisplayString(max) + " ", 1 /* TEXT */),
                  extendedLimits
                    ? (_openBlock(), _createElementBlock("b", _hoisted_7, "(" + _toDisplayString(extendedLimits) + " excp.)", 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_el_table_column, {
        label: "Availability for organics",
        align: "center",
        width: "100"
      }, {
        default: _withCtx(({ row }) => [
          _createVNode(_component_el_text, {
            type: _ctx.getOrganicsAvailabilityData(row).type
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.getOrganicsAvailabilityData(row).value), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"])
        ]),
        _: 1 /* STABLE */
      }),
      (_ctx.isDepositColumnsDataVisible)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 4,
            label: "Unavailable hours",
            align: "center",
            width: "100"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_text, {
                type: _ctx.getAvailabilityHoursData(row.isUnavailableHoursActive).type
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getAvailabilityHoursData(row.isUnavailableHoursActive).value), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (_ctx.isDepositColumnsDataVisible)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 5,
            label: "Deposit",
            align: "center",
            width: "120"
          }, {
            default: _withCtx(({ row }) => [
              (row.type === _ctx.GeoPaymentMethodTypes.SINGLE)
                ? (_openBlock(), _createBlock(_component_PaymentMethodToggle, {
                    key: 0,
                    "payment-method-item": row,
                    "geo-payment-method-property": _ctx.GeoPaymentMethodColumnProperties.DEPOSIT_ENABLED,
                    onUpdateGeoPaymentMethod: _ctx.switchPaymentMethod
                  }, null, 8 /* PROPS */, ["payment-method-item", "geo-payment-method-property", "onUpdateGeoPaymentMethod"]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (_ctx.isWithdrawColumnsDataVisible)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 6,
            label: "Withdrawal",
            align: "center",
            width: "120"
          }, {
            default: _withCtx(({ row }) => [
              (row.type === _ctx.GeoPaymentMethodTypes.SINGLE)
                ? (_openBlock(), _createBlock(_component_PaymentMethodToggle, {
                    key: 0,
                    "payment-method-item": row,
                    "geo-payment-method-property": _ctx.GeoPaymentMethodColumnProperties.WITHDRAW_ENABLED,
                    onUpdateGeoPaymentMethod: _ctx.switchPaymentMethod
                  }, null, 8 /* PROPS */, ["payment-method-item", "geo-payment-method-property", "onUpdateGeoPaymentMethod"]))
                : (row.type === _ctx.GeoPaymentMethodTypes.MULTI)
                  ? (_openBlock(), _createBlock(_component_el_switch, {
                      key: 1,
                      modelValue: row['withdrawalAvailable'],
                      "onUpdate:modelValue": ($event: any) => ((row['withdrawalAvailable']) = $event),
                      onChange: ($event: any) => (_ctx.updateGeoMultiMethodWithdrawState(row))
                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "onChange"]))
                  : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (_ctx.isActionsColumnVisible)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 7,
            label: "Actions",
            align: "center",
            width: "80"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_8, [
                (_ctx.isSettingsButtonAllowed && row.type === _ctx.GeoPaymentMethodTypes.SINGLE)
                  ? (_openBlock(), _createBlock(_component_el_dropdown, {
                      key: 0,
                      trigger: "click",
                      onCommand: ($event: any) => (_ctx.getGeoDropdownActionCommand($event, row))
                    }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              disabled: !_ctx.isUpdateGeoPaymentMethodAllowed,
                              command: {
                    action: _ctx.GeoDropdownActionCommand.OPEN_EDIT_PAYMENT_METHOD,
                  }
                            }, {
                              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode(" General settings ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "command"]),
                            (_ctx.isUpdateGeoPaymentMethodDepositLimitsAllowed && _ctx.isDepositColumnsDataVisible)
                              ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                  key: 0,
                                  command: {
                    action: _ctx.GeoDropdownActionCommand.OPEN_PSP_LIMITS_SETTINGS,
                  }
                                }, {
                                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                    _createTextVNode(" PSP deposit limits ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["command"]))
                              : _createCommentVNode("v-if", true),
                            _createVNode(_component_el_dropdown_item, {
                              disabled: !_ctx.isGetGeoPaymentMethodExtendedLimitAllowed,
                              command: {
                    action: _ctx.GeoDropdownActionCommand.OPEN_EXCEPTION_LIMIT_SETTINGS,
                    operationType: _ctx.PaymentMethodExceptionLimitType.DEPOSIT,
                  }
                            }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode(" Exception deposit limits ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "command"]),
                            _createVNode(_component_el_dropdown_item, {
                              disabled: !_ctx.isGetGeoPaymentMethodExtendedLimitAllowed,
                              command: {
                    action: _ctx.GeoDropdownActionCommand.OPEN_EXCEPTION_LIMIT_SETTINGS,
                    operationType: _ctx.PaymentMethodExceptionLimitType.WITHDRAWAL,
                  }
                            }, {
                              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode(" Exception withdrawal limits ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "command"]),
                            _createVNode(_component_el_dropdown_item, {
                              disabled: !_ctx.isGetGeoPaymentMethodSetAvailabilityLimitAllowed,
                              command: {
                    action: _ctx.GeoDropdownActionCommand.OPEN_UNAVAILABLE_HOURS_SETTINGS,
                  }
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode(" Unavailable hours ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "command"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          icon: _ctx.icons.Setting,
                          circle: "",
                          size: "small"
                        }, null, 8 /* PROPS */, ["icon"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onCommand"]))
                  : _createCommentVNode("v-if", true),
                (row.type === _ctx.GeoPaymentMethodTypes.MULTI)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      icon: _ctx.icons.Edit,
                      circle: "",
                      size: "small",
                      class: "geo-payment-methods__action-button",
                      onClick: ($event: any) => (_ctx.openMultiMethodPage(row))
                    }, null, 8 /* PROPS */, ["icon", "onClick"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.isDeleteGeoPaymentMethodAllowed)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      icon: _ctx.icons.Delete,
                      type: "danger",
                      circle: "",
                      size: "small",
                      class: "geo-payment-methods__action-button",
                      onClick: ($event: any) => (_ctx.requestDeleteConfirmation(row))
                    }, null, 8 /* PROPS */, ["icon", "onClick"]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data", "row-class-name"])), [
    [_directive_loading, _ctx.isGeoPaymentMethodListLoading]
  ])
}